import useCopyToClipboard from '~/hooks/useCopyToClipboard';
import useStaticSubscriptionReferrals from '~/hooks/useLoaders/useStaticSubscriptionReferrals';

export type OnClickCopyFn = (link: string) => void;

export const useStaticReferrals = ({ subscriberId, enabled }: { subscriberId: string; enabled: boolean }) => {
  const { data: referrals, isLoading } = useStaticSubscriptionReferrals({
    enabled: enabled,
    subscriberId: subscriberId || '',
  });

  const copy = useCopyToClipboard();
  const onClickCopy: OnClickCopyFn = (link) => {
    copy(link);
  };

  return {
    isLoading,
    referrals: referrals?.referrals,
    rewards: referrals?.rewards,
    referralCount: referrals?.referral_count,
    referralLink: referrals?.referral_link,
    onClickCopy,
  };
};
